import React from 'react'
import styled from 'styled-components'

const DateRangeLabel = styled.div`
  font-size: 1.5em;
  margin-right: 0.4em;
  font-weight: bold;
  color: #555;
`

const PeriodLabel = ({
  yearly,
  year,
  period: { from, to },
  render = a => a,
  className,
  style,
}) => (
  <DateRangeLabel {...{ className, style }}>
    {render(
      yearly ? year : `${from.year}/${from.month} - ${to.year}/${to.month}`
    )}
  </DateRangeLabel>
)

export default PeriodLabel
